import { render, staticRenderFns } from "./LoaderSplash.vue?vue&type=template&id=c31f5218"
import script from "./LoaderSplash.vue?vue&type=script&lang=js"
export * from "./LoaderSplash.vue?vue&type=script&lang=js"
import style0 from "./LoaderSplash.vue?vue&type=style&index=0&id=c31f5218&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports